"use strict";

var $ = jQuery.noConflict();

function accordionInit() {
  // <div class="accordion">
  //   <ul>
  //     <li>
  //       <h3 class="expander">Title 1</h3>
  //       <div class="expander-target">Content here 1</div>
  //     </li>
  //     <li>
  //       <h3 class="expander">Title 2</h3>
  //       <div class="expander-target">Content here 2</div>
  //     </li>
  //   </ul>
  // </div>
  if ($('.accordion').length) {
    var accordion = $('.accordion > ul');
    $('.expander-target', accordion).slideUp(500);
    $('.expander', accordion).click(function () {
      if ($(this).parents('li').hasClass('active')) {
        $(this).siblings('.expander-target').slideUp(500);
        $(this).parents('li').removeClass('active');
      } else {
        $(this).parents('ul').find('li.active .expander-target').slideUp(500);
        $(this).parents('ul').find('li.active').removeClass('active');
        $(this).siblings('.expander-target').slideToggle(500);
        $(this).parents('li').toggleClass('active');
      }
    });
  }
}

$(document).ready(function () {
  accordionInit();
});